<template>
  <button
    :class="[
      'inline-flex items-center border border-mid-grey rounded-full  text-sm font-medium transition-colors',
      active ? 'bg-bkk-50 text-black' : 'bg-white text-black',
    ]"
    tabindex="0"
  >
    <div
      v-if="iconPosition === 'right'"
      class="mr-2 flex flex-row justify-between w-full text-medium items-center px-4 py-1 pr-0"
    >
      {{ label }} <component :is="icon" class="h-7 w-7 bg-white rounded-full" />
    </div>
    <div v-else class="flex flex-row px-2 py-1">
      <component :is="icon" class="h-4 w-4 mr-2 mt-0.5" />{{ label }}
    </div>
  </button>
</template>

<script setup lang="ts">
import { defineProps } from "vue";

const props = defineProps<{
  label: string;
  icon: any;
  iconPosition?: "left" | "right";
  active?: boolean;
}>();
</script>
